import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

// The search param a link uses to ask a page to open something on arrival,
// e.g. /u/will/profile?add=standout opens the standout picker
export const INTENT_PARAM = "add";

/**
 * Runs `onIntent` once when the URL carries `?add=<intent>`, then strips the
 * param (replacing the history entry), so a refresh or back/forward doesn't
 * reopen it. `enabled` gates it, e.g. to the owner of a profile.
 */
export default function useUrlIntent(
  intent,
  onIntent,
  { enabled = true } = {},
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const isRequested = searchParams.get(INTENT_PARAM) === intent;
  // Latest callback without re-running the effect when it changes
  const onIntentRef = useRef(onIntent);
  onIntentRef.current = onIntent;

  useEffect(() => {
    if (!enabled || !isRequested) return;
    onIntentRef.current();
    setSearchParams(
      (previous) => {
        const next = new URLSearchParams(previous);
        next.delete(INTENT_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [enabled, isRequested, setSearchParams]);
}
